import { useMutation } from '@tanstack/react-query';
import { answerQuiz } from '../queries/quiz';

function useAnswerQuiz() {
  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: ({ quizId, exerciseId, answerId, isCorrect }: {
      quizId: string;
      exerciseId: string;
      answerId: string;
      isCorrect: boolean;
    }) => answerQuiz(quizId, exerciseId, answerId, isCorrect),
  });

  return {
    answerQuiz: mutate,
    isAnswering: isPending,
    isError,
    error,
  };
}

export { useAnswerQuiz };
